// src/pages/Suspended/Suspended.jsx
import { useEffect } from "react";
import { motion as Motion } from "framer-motion";

// Reuse your existing Underage module styles for identical layout
import cls from "../Underage/Underage.module.scss";

import FooterMobile from "@/components/NotyFooter/FooterMobile";
import FooterDesktop from "@/components/NotyFooter/FooterDesktop";

// TEMP art: reuse the same image; swap to a “suspended” art when you have one
import underAgeGirl from "@/assets/UI/under-age-girl.png";

export default function Suspended() {
  useEffect(() => {
    // If you want, clear any age/safety flags (optional)
    try {
      localStorage.removeItem("cm_age_ok");
    } catch {
      // Intentionally ignored: localStorage cleanup failure should not block the UI.
    }
  }, []);

  const slideInLeft = {
    hidden: { opacity: 0, x: -48 },
    show: { opacity: 1, x: 0, transition: { duration: 0.65, ease: "easeOut" } },
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 48 },
    show: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.75, ease: "easeOut", delay: 0.05 },
    },
  };

  const slideInRightMobile = {
    hidden: { x: "50vw", opacity: 0 },
    show: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 220,
        damping: 24,
        mass: 0.9,
        delay: 0.05,
      },
    },
  };

  const slideInLeftMobile = {
    hidden: { x: "-40vw", opacity: 0 },
    show: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 220, damping: 24, mass: 0.9 },
    },
  };

  return (
    <>
      <main className={cls.agegate}>
        {/* MOBILE */}
        <section className="nu-mobile nu-bg--mobile">
          <div className={cls.stage}>
            {/* BACK art */}
            <Motion.div
              className={`${cls.frame} ${cls["frame--art"]} glow-2`}
              variants={slideInRightMobile}
              initial="hidden"
              animate="show"
              aria-hidden="true"
            >
              <div className={cls.artWrap}>
                <img src={underAgeGirl} alt="" className={cls.art} />
              </div>
            </Motion.div>

            {/* FRONT message */}
            <Motion.div
              className={`${cls.frame} ${cls["frame--primary"]} alpha-15`}
              variants={slideInLeftMobile}
              initial="hidden"
              animate="show"
            >
              <h1 className="nu-title is-mr" data-glow="1">
                Account Suspended
              </h1>
              <p
                className="nu-subtitle is-mrs"
                data-glow="1"
                style={{ marginTop: 10 }}
              >
                Your account is currently suspended. Please contact our support
                team.
              </p>

              <div className={cls.actions} style={{ marginTop: 16 }}>
                <a
                  href="https://wa.me/14036045056?text=Hello%20Noty%20Support%2C%20my%20account%20has%20been%20suspended.%20Please%20help%20me%20restore%20access."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nu-btn is-mr nu-btn--lg nu-btn--green"
                >
                  💬 Contact Support on WhatsApp
                </a>
              </div>
            </Motion.div>
          </div>
        </section>

        {/* DESKTOP */}
        <section
          className="nu-desktop nu-bg--desktop"
          aria-label="Suspended notice"
        >
          <div className={cls.stage}>
            {/* Text side */}
            <Motion.div
              className={`${cls.frame} ${cls["frame--primary"]} glow-2`}
              variants={slideInLeft}
              initial="hidden"
              animate="show"
            >
              <h1 className="nu-title is-mr" data-glow="1">
                Account Suspended
              </h1>
              <p
                className="nu-subtitle is-mrs"
                data-glow="1"
                style={{ marginTop: 10 }}
              >
                Your account is currently suspended. Please contact our support
                team.
              </p>

              <div className={cls.actions} style={{ marginTop: 16 }}>
                <a
                  href="https://wa.me/14036045056?text=Hello%20Noty%20Support%2C%20my%20account%20has%20been%20suspended.%20Please%20help%20me%20restore%20access."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nu-btn is-mr nu-btn--lg nu-btn--green"
                >
                  💬 Contact Support on WhatsApp
                </a>
              </div>
            </Motion.div>

            {/* Image side */}
            <div className={cls.artLayer}>
              <Motion.aside
                className={`${cls.frame} ${cls["frame--art"]}`}
                variants={slideInRight}
                initial="hidden"
                animate="show"
                aria-hidden="true"
              >
                <div className={cls.artWrap}>
                  <img src={underAgeGirl} alt="" className={cls.art} />
                </div>
              </Motion.aside>
            </div>
          </div>
        </section>
      </main>

      <FooterMobile />
      <FooterDesktop />
    </>
  );
}
